import { SwiperOptions } from 'swiper';

/**
 * Configuration for SwiperJs, on which navigation logic is built
 */
export const SWIPER_OPTIONS: SwiperOptions = {
  slidesPerView: 'auto',
  freeMode: true
};
